(function(){
	"use strict";
	var overlay = null;
	
	function createOverlay(){
		if(overlay) return overlay;
		overlay = document.createElement('div');
		overlay.className = 'ln-swatch-lightbox';
		overlay.innerHTML = '<div class="ln-swatch-lightbox__inner"><button class="ln-swatch-lightbox__close" aria-label="Close">×</button><img class="ln-swatch-lightbox__img" alt=""><div class="ln-swatch-lightbox__caption"></div></div>';
		document.body.appendChild(overlay);
		overlay.addEventListener('click', function(e){
			if(e.target === overlay || e.target.className === 'ln-swatch-lightbox__close'){
				close();
			}
		});
		document.addEventListener('keydown', function(e){
			if(e.key === 'Escape' && overlay.classList.contains('is-open')){ close(); }
		});
		return overlay;
	}
	function open(src, caption){
		var o = createOverlay();
		o.querySelector('.ln-swatch-lightbox__img').src = src;
		o.querySelector('.ln-swatch-lightbox__img').alt = caption || '';
		o.querySelector('.ln-swatch-lightbox__caption').textContent = caption || '';
		setTimeout(function(){ o.classList.add('is-open'); }, 10);
		document.body.style.overflow = 'hidden';
	}
	function close(){
		if(!overlay) return;
		overlay.classList.remove('is-open');
		document.body.style.overflow = '';
	}
	
	// Extract URL from CSS background-image
	function getBgUrl(el){
		var bg = el.style.backgroundImage || getComputedStyle(el).backgroundImage;
		var m = bg.match(/url\(["']?([^"')]+)["']?\)/);
		return m ? m[1] : null;
	}
	
	// Init : listen to tartan swatch clicks
	function init(){
		// Product page tartan swatches
		document.querySelectorAll('.ln-tartan-swatch').forEach(function(sw){
			if(sw.dataset.lnLb) return;
			sw.dataset.lnLb = '1';
			sw.style.cursor = 'zoom-in';
			sw.addEventListener('click', function(e){
				var url = getBgUrl(sw);
				var name = sw.title || '';
				if(!url){
					var innerImg = sw.querySelector('img');
					if(innerImg){ url = innerImg.currentSrc || innerImg.src; if(!name) name = innerImg.alt || ''; }
				}
				if(url){ e.preventDefault(); open(url, name); }
			});
		});
		// Materials page : images dans les grilles de la page /pages/materials
		document.querySelectorAll('body.template-page-materials img, [class*="page-materials"] img').forEach(function(img){
			if(img.dataset.lnLb) return;
			if(img.width > 0 && img.width < 200){
				img.dataset.lnLb = '1';
				img.style.cursor = 'zoom-in';
				img.addEventListener('click', function(){
					open(img.src, img.alt);
				});
			}
		});
		// Aussi : side panel materials (le panel qu'on ouvre depuis les fiches produit)
		document.querySelectorAll('.side-panel-content--inner img').forEach(function(img){
			if(img.dataset.lnLb) return;
			img.dataset.lnLb = '1';
			img.style.cursor = 'zoom-in';
			img.addEventListener('click', function(){
				open(img.src, img.alt);
			});
		});
	}
	if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
	document.addEventListener('shopify:section:load', init);
	// Re-init after any DOM changes (for side panels that open async)
	var mo = new MutationObserver(function(){ init(); });
	mo.observe(document.body, {childList:true, subtree:true});
})();